import moment, {Moment} from 'moment';

export default class Person {
    constructor(public ip: string = '', public lastConnection: Moment = moment(), public country: string = '') {
    }
}
